/** @format */
import { post, download } from '@root/utils/httpWrap';

function transformParam(p: any) {
  return {
    ...p,
    userId: ''
  };
}
/**
 * 电子发票列表
 *
 * @format
 */
/**
 * 财务报表查询-日报表-机构维度
 */
export const queryDailyReport = (params: any): Promise<ProjectResponse<any>> => {
  return post('bangdao/saasapi/v1/reportOrg/dayReportList', transformParam(params));
};
export const queryDailyReportOld = (params: any): Promise<ProjectResponse<any>> => {
  return post('bangdao/saasapi/v1/dayReport/list', transformParam(params));
};

/**
 * 财务报表记录导出-日报表-机构维度
 * @param params
 */
export const exportDailyReport = (params: any, fileName?: string): any => {
  return download('bangdao/saasapi/v1/reportOrg/orgReportExport', transformParam(params), fileName);
};

/**
 * 临停收费报表-机构维度-日报表
 * @param params
 */
export const queryDayReportList = (params: any, fileName?: string): any => {
  return download('bangdao/saasapi/v1/temporaryOrg/dayReportList', transformParam(params), fileName);
};
/**
 * 收费员结账统计表列表查询
 * @param params
 */
export const getSettleReport = (params: any): Promise<ProjectResponse<any>> => {
  return post('bangdao/saasapi/v1/account/settleReport', params);
};

/**
 * 收费员结账统计表导出
 * @param params
 */
export const exportSettleReport = (params: any, fileName?: string): Promise<ProjectResponse<any>> => {
  return download('bangdao/saasapi/v1/account/exportSettleReport', params, fileName);
};

/**
 * 收费员交接班统计表列表查询
 * @param params
 */
export const getSentryHandoverRecord = (params: any): any => {
  return post('bangdao/saasapi/v1/sentryHandoverRecord/getRecordList', params);
};

/**
 * 收费员交接班统计表导出
 * @param params
 */
export const exportSentryHandoverRecord = (params: any, fileName?: string): any => {
  return download('bangdao/saasapi/v1/sentryHandoverRecord/exportRecordListExcel', params, fileName);
};

/**
 * 运营报表
 * @param params
 */
export const queryBusinessReport = (params: any): any => {
  return post('bangdao/saasapi/v1/account/getOperationReportByCondition', params);
};

/**
 * 运营报表
 * @param params
 */
export const queryChannelList = (params: any): any => {
  return post('bangdao/saasapi/v1/account/ChannelList', params);
};

/**
 * 运营报表合计
 * @param params
 */
export const queryBusinessReportSummary = (params: any): Promise<ProjectResponse<any>> => {
  return post('bangdao/saasapi/v1/account/getOperationReportSummary', params);
};
/**
 * 获取电子发票开票记录列表
 * @param params
 */
export const getInvoiceRecordList = (params: any): Promise<ProjectResponse<any>> => {
  return post('bangdao/saasapi/v1/invoiceRecord/list', params);
};

/**
 * 电子发票导出
 * @param params
 */
export const downloadInvoiceLift = (params: any, fileName?: string): Promise<ProjectResponse<any>> => {
  return download('bangdao/saasapi/v1/invoiceRecord/export', params, fileName);
};

/**
 * 运营报表导出
 * @param params
 */
export const exportBusinessReport = (params: any): any => {
  return download('bangdao/saasapi/v1/account/exportOperationReportExcle', params);
};
/**
 * 机动车异常抬杆率弹框
 * @param params
 */

export const carAbnormalLiftRate = (params: any): Promise<ProjectResponse<any>> => {
  return post('bangdao/saasapi/v1/account/carAbnormalLiftRate', params);
};

/**
 * 预收月度分摊表列表
 * @param params
 */

export const contributionQueryList = (params: any): Promise<ProjectResponse<any>> => {
  return post('/bangdao/saasapi/v1/share/list', params);
};
/**
 * 预收月度分摊表导出
 * @param params
 */
export const contributionExport = (params: any, fileName?: string): any => {
  return download('/bangdao/saasapi/v1/share/export', params, fileName);
};
